import { createFileRoute } from "@tanstack/react-router";
import { Package } from "lucide-react";
import { EmptyState } from "@/components/kit/index.js";

export const Route = createFileRoute("/_authenticated/catalog/products")({
  component: ProductsPage,
});

function ProductsPage() {
  return (
    <EmptyState
      title="Products"
      description="Product authoring arrives in a later release. The catalog's pieces will be built here."
      icon={Package}
      meanwhile={{ label: "Build the vocabulary first", to: "/catalog/vocabulary" }}
    />
  );
}
